'use client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React from 'react';

// Must stay a static `process.env.X` member expression — Turbopack only
// inlines NEXT_PUBLIC_* vars into the client bundle on an exact match, so
// `process?.env?.X` resolves to undefined in the browser.
const recaptchaKey: string | undefined =
  process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

export const GoogleReCaptchaContext = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (!recaptchaKey) {
    console.error(
      'NEXT_PUBLIC_RECAPTCHA_SITE_KEY is missing from the build — reCAPTCHA cannot load and form submissions will fail.',
    );
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey ?? 'NOT DEFINED'}>
      {children}
    </GoogleReCaptchaProvider>
  );
};
